/* 👻🚨👻🚨👻 Let op! This code has been auto generated, so best not to touch it 👻🚨👻🚨👻 */
import * as Types from '@repo/graphql-types';

import type { FetchOptions } from 'codegen/fetcher/fetcher.types'
import { fetcher } from 'codegen/fetcher'
import { useQuery, type UseQueryOptions } from '@tanstack/react-query'
export type SiteProductCountDataQueryVariables = Types.Exact<{ [key: string]: never; }>;


export type SiteProductCountDataQuery = { __typename?: 'Query', siteData: { __typename?: 'SiteData', productCounts: { __typename?: 'ProductCounts', fonts: number, crafts: number, graphics: number, embroidery: number } } };

export type SiteDataQueryVariables = Types.Exact<{
  source?: Types.InputMaybe<Types.Source>;
}>;


export type SiteDataQuery = { __typename?: 'Query', siteData: { __typename?: 'SiteData', newsletterPopup?: { __typename: 'NewsletterPopup', type: Types.SitePopupType, title: string, text: string, closeText: string, footerText: string, backgroundImageSrc: string, button: { __typename?: 'NewsletterPopupButton', backgroundColor: string, text: string, link?: string | null } } | null, onHoldSubscriptionBanner?: { __typename: 'OnHoldSubscriptionBanner', type: Types.SiteBannerType, backgroundColor: string, text: string, bannerAboveNav: string, bannerAboveNavState: string } | null, undoCancelationBanner?: { __typename: 'UndoCancelationBanner', type: Types.SiteBannerType, backgroundColor: string, text: string, subscriptionId: string, bannerAboveNav: string, bannerAboveNavState: string, button: { __typename?: 'UndoCancelationBannerButton', backgroundColor: string, text: string, textColor: string, hoverTextColor: string, onClick: string, link?: string | null }, countdown: { __typename?: 'SiteBannerCountdown', value: string, text: string } } | null } };


export const SiteProductCountDataDocument = `
query siteProductCountData {
  siteData {
    productCounts {
      fonts
      crafts
      graphics
      embroidery
    }
  }
}

`

export const siteProductCountDataQueryRootKey = 'siteProductCountData'

export function siteProductCountDataQueryFetcher(variables?: SiteProductCountDataQueryVariables, fetchOptions?: FetchOptions) {
    return fetcher<SiteProductCountDataQuery, SiteProductCountDataQueryVariables>(SiteProductCountDataDocument, variables, fetchOptions?.headers, fetchOptions)
}

// hello curious person. if you are here and wondering why the typing is so complicated,
// it's bcos fetchOptions need to be considered as part of the query key.
// they are able to affect the response of the query, so they need to be part of the cache key.
export function siteProductCountDataQueryKey(variables?: SiteProductCountDataQueryVariables, fetchOptions?: FetchOptions) {
    const key: (string | FetchOptions)[]  = [siteProductCountDataQueryRootKey]
    if (fetchOptions) {key.push(fetchOptions)}
    return variables === undefined ? key : [...key, variables]
}

export function siteProductCountDataQueryOptions(
    variables?: SiteProductCountDataQueryVariables,
    fetchOptions?: FetchOptions
): Pick<UseQueryOptions<SiteProductCountDataQuery, unknown, SiteProductCountDataQuery, (SiteProductCountDataQueryVariables | FetchOptions | string)[]>, 'queryKey' | 'queryFn'> {
    return {
        queryKey: siteProductCountDataQueryKey(variables, fetchOptions),
        queryFn: siteProductCountDataQueryFetcher(variables, fetchOptions),
    }
}

export function useSiteProductCountDataQuery<D = SiteProductCountDataQuery, E = unknown>(
    variables?: SiteProductCountDataQueryVariables,
    options?: Omit<UseQueryOptions<SiteProductCountDataQuery, E, D, (SiteProductCountDataQueryVariables | FetchOptions | string)[]>, 'queryKey' | 'queryFn'>,
    fetchOptions?: FetchOptions
) {
    return useQuery<SiteProductCountDataQuery, E, D, (SiteProductCountDataQueryVariables | FetchOptions | string)[]>({
        ...options,
        ...siteProductCountDataQueryOptions(variables, fetchOptions),
    })
}

export const SiteDataDocument = `
query siteData($source: Source) {
  siteData(source: $source) {
    newsletterPopup {
      __typename
      type
      title
      text
      closeText
      footerText
      backgroundImageSrc
      button {
        backgroundColor
        text
        link
      }
    }
    onHoldSubscriptionBanner {
      __typename
      type
      backgroundColor
      text
      bannerAboveNav
      bannerAboveNavState
    }
    undoCancelationBanner {
      __typename
      type
      backgroundColor
      text
      subscriptionId
      bannerAboveNav
      bannerAboveNavState
      button {
        backgroundColor
        text
        textColor
        hoverTextColor
        onClick
        link
      }
      countdown {
        value
        text
      }
    }
  }
}

`

export const siteDataQueryRootKey = 'siteData'

export function siteDataQueryFetcher(variables?: SiteDataQueryVariables, fetchOptions?: FetchOptions) {
    return fetcher<SiteDataQuery, SiteDataQueryVariables>(SiteDataDocument, variables, fetchOptions?.headers, fetchOptions)
}

// hello curious person. if you are here and wondering why the typing is so complicated,
// it's bcos fetchOptions need to be considered as part of the query key.
// they are able to affect the response of the query, so they need to be part of the cache key.
export function siteDataQueryKey(variables?: SiteDataQueryVariables, fetchOptions?: FetchOptions) {
    const key: (string | FetchOptions)[]  = [siteDataQueryRootKey]
    if (fetchOptions) {key.push(fetchOptions)}
    return variables === undefined ? key : [...key, variables]
}

export function siteDataQueryOptions(
    variables?: SiteDataQueryVariables,
    fetchOptions?: FetchOptions
): Pick<UseQueryOptions<SiteDataQuery, unknown, SiteDataQuery, (SiteDataQueryVariables | FetchOptions | string)[]>, 'queryKey' | 'queryFn'> {
    return {
        queryKey: siteDataQueryKey(variables, fetchOptions),
        queryFn: siteDataQueryFetcher(variables, fetchOptions),
    }
}

export function useSiteDataQuery<D = SiteDataQuery, E = unknown>(
    variables?: SiteDataQueryVariables,
    options?: Omit<UseQueryOptions<SiteDataQuery, E, D, (SiteDataQueryVariables | FetchOptions | string)[]>, 'queryKey' | 'queryFn'>,
    fetchOptions?: FetchOptions
) {
    return useQuery<SiteDataQuery, E, D, (SiteDataQueryVariables | FetchOptions | string)[]>({
        ...options,
        ...siteDataQueryOptions(variables, fetchOptions),
    })
}